var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "rg-tab-list" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "li",
        {
          key: item.value,
          staticClass: "rg-tab-item",
          class: { "rg-tab-item--active": _vm.local_value == item.value },
        },
        [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.local_value = item.value
                },
              },
            },
            [
              _vm.heading
                ? _c("h2", { staticClass: "rg-tab-heading" }, [
                    _vm._v(_vm._s(item.label)),
                  ])
                : [_vm._v(_vm._s(item.label))],
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }